import { render, staticRenderFns } from "./wfd.vue?vue&type=template&id=4c21a18d&scoped=true"
import script from "./wfd.vue?vue&type=script&lang=js"
export * from "./wfd.vue?vue&type=script&lang=js"
import style0 from "./wfd.vue?vue&type=style&index=0&id=4c21a18d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21a18d",
  null
  
)

export default component.exports